import React, { useState } from 'react';
import { validate } from 'validate.js';
import { useNavigate } from "react-router-dom";
import { Button, Card, Form, Icon, Input } from 'antd';
import { normalizeUrl } from '../shared/utils';
import { urlValidationRule } from './utils';
import useStartAnalysis from '../analysis/hooks/useStartAnalysis';


export default function AnalysisForm() {
    const navigate = useNavigate();

    const [urlValue, setUrlValue] = useState<string>('');
    const [urlValidationError, setUrlValidationError] = useState<string>('');

    const { startAnalysis } = useStartAnalysis();

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        const normalizedUrl = normalizeUrl(urlValue, 'https://');
        const validationError = validate({ url: normalizedUrl }, urlValidationRule);

        if (validationError) {
            setUrlValidationError(validationError.url[0]);
            return;
        }

        startAnalysis(normalizedUrl);
        navigate('/analysis/report');
    };

    const handleUrlInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUrlValue(event.target.value);
        setUrlValidationError('');
    };

    return (
        <Card className="analysis-form-card">
            <Form
                onSubmit={handleSubmit}
                className="analysis-form"
            >
                <Form.Item
                    validateStatus={urlValidationError ? 'error' : 'validating'}
                    help={urlValidationError ? urlValidationError : ''}
                >
                    <Input.Group
                        compact
                        size="large"
                    >
                        <div className="compact-input-group">
                            <Input
                                autoCorrect="off"
                                autoCapitalize="off"
                                prefix={<Icon type="global" style={{ color: "rgba(0,0,0,.25)" }} />}
                                placeholder="Quick SEO Checkup — Enter URL"
                                name="url"
                                size="large"
                                value={urlValue}
                                onChange={handleUrlInputChange}
                            />

                            <Button
                                type="primary"
                                htmlType="submit"
                                size="large"
                            >
                                Analyze URL
                            </Button>
                        </div>
                    </Input.Group>
                </Form.Item>
            </Form>
        </Card>
    );
}
